module.exports = {"530829101":"勐梭镇","530829102":"勐卡镇","530829103":"翁嘎科镇","530829104":"中课镇","530829105":"新厂镇","530829202":"力所拉祜族乡","530829203":"岳宋乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530829.json
// module id = 2414
// module chunks = 0